import { globalCache } from "./init/sdkInit";
import { getListOfItems } from "./ops/dataOps/Folder";
import { deletePin } from "./ops/userOps/auth";

export * from "./init/sdkInit";
export * from "./init/config";
export * from "./core/connectionPool";
export * from "./core/connectionPoolTdx";
export * from "./ops/userOps/auth";
export * from "./ops/dataOps/File";
export * from "./ops/dataOps/Folder";
export * from "./ops/dataOps/Item";
export * from "./ops/userOps/role";
export * from "./ops/userOps/byos";
export * from "./ops/userOps/user";
export * from "./ops/userOps/orgnization";
export * from "./ops/userOps/team";
export * from "./ops/userOps/manageUser";
export * from "./proto/bundle";
export * from "./ops/dataOps/task";
export * from "./ops/dataOps/pins";
export * from "./ops/ysentinal/ysentinalQuery";
export * from "./ops/ysentinal/dashboards/index";
export * from "./ops/ysentinal/alerts";
export * from "./ops/dataOps/externalShare";
// export * from "./ops/dataOps/secrets";
export * from "./ops/dataOps/share";
export * from "./ops/dataOps/comments";
export * from "./ops/ysentinal/ledgerFiles";
export * from "./ops/dataOps/plan";
export {
  addUserByEmail,
  addOrgByEmail,
  addUserByToken
} from "./ops/userOps/signUp"

export * from "./ops/userOps/secQuestions";

export let worker: Worker | null = null;
worker = new Worker(new URL("./myWorker.js", import.meta.url), {
  type: "module",
});

export function startWorker() {
  if (!worker) {
    worker = new Worker(new URL("./myWorker.js", import.meta.url));
  }
}

export function terminateWorker() {
  console.log("Terminating worker")
  if (worker) {
    worker.terminate();
    worker = null;
  }
}


worker.onmessage = (e) => {
  const data = e.data;
  if (data.op === "started") {
    worker.postMessage({ op: "start" });
  } else if (data.op === "storageSizeUpdate") {
    sdk.callCallback("storagePercent", data.size, data.limit);
  } else if (data.op == "addList") {
    const list = data.list ?? []
    const folder_path = data.path ?? "/"
    const proccesed = getListOfItems(list, data.regex ?  null:folder_path)
    const pageToken = data.token ?? null
    const page = data.page ?? -1
    let cache_path = folder_path + page.toString()
    if (data.regex) {
      cache_path += "-regex-" + JSON.stringify(data.regex)
    }
    globalCache.set(cache_path, {
      "list": proccesed,
      "token": pageToken
    })
  }
};

export function cleanup() {
  if (globalCache.has("created_pin_name")) {
    const name = globalCache.get("created_pin_name")
    if (globalCache.has(name)) {
      deletePin(globalCache.get(name))
    }
  }
}

// sdk/index.ts

type CallbackMap = {
  [key: string]: (...args: any[]) => any;
};

const callbacks: CallbackMap = {};

export const sdk = {
  registerCallback(name: string, fn: (...args: any[]) => any) {
    callbacks[name] = fn;
  },

  callCallback(name: string, ...args: any[]) {
    if (!callbacks[name]) {
      return;
    }
    return callbacks[name](...args);
  },
};
